export enum LocalStorageKeyType {
  SideNavigationOpen = 'app-layout.side-navigation-open',
  ActiveQuickNavigationItem = 'app-layout.active-quick-navigation-item',
  AgentPanelOpen = 'app-layout.agent-panel-open',
  AgentPanelHistoryOpen = 'app-layout.agent-panel-history-open',
  AgentPanelConversationId = 'app-layout.agent-panel-conversation-id',
  AgentPanelSelectedThread = 'app-layout.agent-panel-selected-thread',
  AgentPanelWidth = 'app-layout.agent-panel-width',
  AiComposerSettings = 'chat.ai-composer-settings',
  WhatsNewDismissedVersion = 'whats-new.dismissed-version',
  DatabaseCellFilesDisplayMode = 'database-cell-files-display-type',
  FolderFilesDisplayMode = 'folder-files-display-type',
}
